import { render, staticRenderFns } from "./JdsPageLayout.vue?vue&type=template&id=48c55f3c&scoped=true&"
import script from "./JdsPageLayout.vue?vue&type=script&lang=ts&"
export * from "./JdsPageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./JdsPageLayout.vue?vue&type=style&index=0&id=48c55f3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c55f3c",
  null
  
)

export default component.exports